import React from "react";
import styled from "styled-components";

const MessageDialogContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5); /* 배경 반투명 */
  z-index: 1000;
`;

const PopupWrap = styled.div`
  width: 450px;
  border: 1px solid #e4dbd2;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
`;

const PopupHeader = styled.div`
  background-color: #e4dcd3;
  font-size: 16px;
  font-weight: bold;
  height: 53px;
  line-height: 53px;
  text-align: center;
`;

const PopupContents = styled.div`
  padding: 10px;
`;

const ContentArea = styled.div`
  padding: 10px;
`;

const Comments = styled.div`
  border: 1px solid #ddd;
  padding: 10px;
`;

const ButtonBottom = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px;
`;

const MessageDialog = ({ title, message, children }) => {
  return (
    <MessageDialogContainer>
      <PopupWrap>
        <PopupHeader>{title}</PopupHeader>

        <PopupContents>
          <ContentArea>
            <Comments>
              <p>{message}</p>
            </Comments>
          </ContentArea>

          <ButtonBottom>{children}</ButtonBottom>
        </PopupContents>
      </PopupWrap>
    </MessageDialogContainer>
  );
};

export default MessageDialog;
